import { render } from "./InvalidToken.vue?vue&type=template&id=7f2b9a6e"
import script from "./InvalidToken.vue?vue&type=script&lang=js"
export * from "./InvalidToken.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__